import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { styled } from 'linaria/react';
import React from 'react';

// import { StyledBreadcrumbs } from '../ui/StyledBreadcrumbs';
import { DynamicPageContentRenderer } from '../ContentComponents/DynamicContentRenderer';
import { HelloRetailContentComponent } from '../ContentComponents/HelloRetailContentComponent';
import { seoComponents } from '../ContentComponents/ContentComponents';

const Content = styled('div')`
  padding-bottom: 1rem;

  p {
    margin-bottom: 1rem;
  }
`;

function ContentPage({ page }) {
  return (
    <>
      <div>
        {/* <StyledBreadcrumbs
            parents={result.data?.route?.parents}
            breadcrumbs={result.data?.route?.breadcrumbs}
          /> */}
        {page ? (
          page.data ? (
            <DynamicPageContentRenderer pageId={page?.id} />
          ) : (
            <Content dangerouslySetInnerHTML={{ __html: page.content }} />
          )
        ) : (
          <LoadingLine
            heightPx={14}
            widthRem={30}
            randomizeWidthBy={10}
            count={10}
            style={{
              marginBottom: '12px'
            }}
          />
        )}
      </div>
      <div className="recommendations">
        <DynamicPageContentRenderer
          pageId={page?.id}
          rendererComponents={{
            HELLORETAILPRODUCTROW: HelloRetailContentComponent
          }}
        />
      </div>
      <div className="seo">
        <DynamicPageContentRenderer
          pageId={page?.id}
          rendererComponents={seoComponents}
        />
      </div>
    </>
  );
}

export default ContentPage;
